import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7240e032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-grid__block" }
const _hoisted_2 = {
  key: 0,
  class: "profile-headline"
}
const _hoisted_3 = { class: "profile-headline__text-wrapper" }
const _hoisted_4 = { class: "profile-headline__title" }
const _hoisted_5 = {
  key: 1,
  class: "profile-headline"
}
const _hoisted_6 = {
  key: 0,
  class: "profile-headline__text-wrapper"
}
const _hoisted_7 = { class: "profile-headline__title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-question" }, null, -1))
const _hoisted_9 = {
  key: 3,
  class: "affiliate-panel__hint"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AffiliateLinkEditModal = _resolveComponent("AffiliateLinkEditModal")!
  const _component_ContentPlaceholdersText = _resolveComponent("ContentPlaceholdersText")!
  const _component_ContentPlaceholders = _resolveComponent("ContentPlaceholders")!
  const _component_ElTooltip = _resolveComponent("ElTooltip")!
  const _component_PxIcon = _resolveComponent("PxIcon")!
  const _component_PxButton = _resolveComponent("PxButton")!
  const _component_PxPanel = _resolveComponent("PxPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AffiliateLinkEditModal, {
      ref: "affiliateLinkEditModal",
      visibility: _ctx.isAffiliateLinkEditModalVisible,
      "onUpdate:visibility": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isAffiliateLinkEditModalVisible) = $event))
    }, null, 8, ["visibility"]),
    (_ctx.$screen.smDown)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("profile.affiliateLink.title")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PxPanel, { class: "profile-panel" }, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_ContentPlaceholders, {
              key: 0,
              rounded: true
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ContentPlaceholdersText, { lines: 2 })
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (!_ctx.$screen.smDown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("profile.affiliateLink.title")), 1),
                    _createVNode(_component_ElTooltip, {
                      placement: "top",
                      "popper-class": "affiliate-panel__tooltip el-abaca-tooltip"
                    }, {
                      content: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("profile.affiliateLink.hint")), 1)
                      ]),
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.hasAffiliateLink)
                ? (_openBlock(), _createBlock(_component_PxButton, {
                    key: 1,
                    class: "affiliate-panel__button",
                    type: "primary",
                    onClick: _ctx.onClickGenerate
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PxIcon, {
                        size: 18,
                        class: "affiliate-panel__button-icon",
                        name: "link--white"
                      }),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("profile.affiliateLink.newLink")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : (_openBlock(), _createBlock(_component_ElTooltip, {
                    key: 2,
                    "show-arrow": false,
                    "auto-close": 2000,
                    trigger: "click",
                    placement: "bottom",
                    "popper-class": "affiliate-panel__copied-tooltip el-abaca-tooltip"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.$t("profile.affiliateLink.copyClipboard")), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_PxButton, {
                        class: "affiliate-panel__button",
                        type: "ghost-blue",
                        onClick: _ctx.onClickCopyLink
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_PxIcon, {
                            size: 18,
                            class: "affiliate-panel__button-icon",
                            name: "link"
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t("profile.affiliateLink.copyLink")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })),
              (_ctx.$screen.mdDown)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("profile.affiliateLink.hint")), 1))
                : _createCommentVNode("", true)
            ]))
      ]),
      _: 1
    })
  ]))
}